import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Divider, Row, Space, Spin } from 'antd'
import { isEmpty } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'

import {
  HistoryLink,
  NodeBreadcrumbs,
} from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import { EVENT_METADATA_TYPES, METADATA_TYPES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { renderCourseTypeEvent } from '../../helpers'
import { useCourseTypeQuery } from '../../hooks'
import {
  CourseTypeImageDetailsForm,
  CourseTypeSimpleDetailsForm,
} from '../forms'

const CourseTypeDetailsPage = () => {
  const { id } = useParams()

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
  } = useCourseTypeQuery(id)

  useDocumentTitle(`${data?.name || 'Loading Course Type...'}`)

  useEffect(() => {
    if (fetchError) {
      showErrorNotification({
        title: 'Course Type error',
        description: fetchError,
      })
    }
  }, [fetchError])

  return isFetchLoading || isEmpty(data) ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <NodeBreadcrumbs
              metadataType={METADATA_TYPES.COURSE_TYPES}
              idPath={data.node.idPath}
              namePath={data.node.namePath}
            />
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={data.updatedAt}
              updatedBy={data.updatedBy?.name}
            />

            <HistoryLink
              renderEvent={renderCourseTypeEvent}
              entityId={id}
              eventMetadataTypes={[EVENT_METADATA_TYPES.COURSE_TYPE]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <CourseTypeSimpleDetailsForm
        courseType={data}
        maxPosition={data.maxPosition}
      />
      <Divider />
      <CourseTypeImageDetailsForm courseType={data} />
    </>
  )
}

export default CourseTypeDetailsPage
